import { debounce } from "lodash";

let _this;

const scrollDebounce = 25;
const loadDebounce = 500;
const defaultLoadPhxEvent = "load_more";
const defaultScrollTreshold = "70";
const scrollTopButtonId = "#scrolltop-button";

export const InfiniteScrollHook = {
  mounted() {
    _this = this;

    this.lastLoadScrollTop = 0;
    this.currentScrollTop = 0;
    this.maxScrollTop = 0;
    this.hadScrollTopOverflow = false;

    this.debouncedResize = debounce(this.resize.bind(this), 100);
    this.resize();
    window.addEventListener("resize", this.debouncedResize);
    this.interval = setInterval(this.debouncedResize, 10_000);

    this.scrollElement = this.el.querySelector(".scrollable");
    const scrollEventListener = debounce(onScroll, scrollDebounce, {
      leading: false,
      trailing: true,
    });
    this.debouncedLoadMore = debounce(onLoad, loadDebounce, {
      leading: true,
      trailing: false,
    });

    this.options = {
      phxLoadEvent: this.el.dataset.phxEvent || defaultLoadPhxEvent,
      phxTarget: this.el.dataset.phxTarget,
      scrollTreshold: Number.parseInt(this.el.dataset.scrollTreshold || defaultScrollTreshold, 10),
    };

    this.scrollTopButton = this.el.querySelector(scrollTopButtonId);
    this.scrollTopArrowIcon = this.scrollTopButton.querySelector(".fa-arrow-up");
    this.scrollTopSpinnerIcon = this.scrollTopButton.querySelector(".fa-spinner");
    if (this.scrollTopButton) {
      this.scrollTopButton.addEventListener("click", () => {
        this.scrollElement.scrollTo({ top: 0, behavior: "smooth" });
      });
    }

    this.scrollElement.addEventListener("scroll", scrollEventListener);

    // manually triggering scroll events, in case the user has scrolled too fast to the bottom
    // of the page (no 'scroll' event is trigger when already at the bottom)
    setInterval(scrollEventListener, 250);
  },
  updated() {
    this.resize();
    if (this.hadScrollTopOverflow) {
      this.scrollElement.scrollTop = this.maxScrollTop;
      this.hadScrollTopOverflow = false;
    } else {
      // When we did not overflow, we want scroll to remain unchanged.
      // And yes, value is 0 otherwise... something else is changing the scroll??
      this.scrollElement.scrollTop = this.currentScrollTop;
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.debouncedResize);
    clearInterval(this.interval);
  },
  resize() {
    const { innerHeight: height } = window;
    const { top } = this.el.getBoundingClientRect();
    const { bottom } = JSON.parse(this.el.dataset.padding);
    this.el.style.height = `${height - top - bottom}px`;
  },
};

const scrollPositionInPercent = () => {
  const scrollTop = _this.scrollElement.scrollTop;
  const scrollHeight = _this.scrollElement.scrollHeight;
  const clientHeight = _this.scrollElement.clientHeight;

  if (scrollHeight !== clientHeight) {
    return (scrollTop / (scrollHeight - clientHeight)) * 100;
  }
  return 0;
};

const setScrollTopButtonVisibility = () => {
  if (_this.scrollTopButton && _this.scrollElement) {
    const scrollTop = _this.scrollElement.scrollTop;
    const clientHeight = _this.scrollElement.clientHeight;
    if (scrollTop > _this.maxScrollTop) {
      _this.maxScrollTop = scrollTop;
      _this.hadScrollTopOverflow = true;
    }
    if (scrollTop > clientHeight) {
      window.liveSocket.execJS(
        _this.scrollTopButton,
        _this.scrollTopButton.getAttribute("data-show"),
      );
    } else {
      window.liveSocket.execJS(
        _this.scrollTopButton,
        _this.scrollTopButton.getAttribute("data-hide"),
      );
    }
  }
};

const onScroll = (_event) => {
  setScrollTopButtonVisibility();
  _this.currentScrollTop = _this.scrollElement.scrollTop;
  if (scrollPositionInPercent() > _this.options.scrollTreshold) {
    _this.debouncedLoadMore();
  }
};

const onLoad = () => {
  if (_this.scrollElement.scrollTop > _this.lastLoadScrollTop) {
    window.liveSocket.execJS(
      _this.scrollTopArrowIcon,
      _this.scrollTopArrowIcon.getAttribute("data-hide"),
    );
    window.liveSocket.execJS(
      _this.scrollTopSpinnerIcon,
      _this.scrollTopSpinnerIcon.getAttribute("data-show"),
    );

    _this.lastLoadScrollTop = _this.scrollElement.scrollTop;
    if (_this.options.phxTarget) {
      _this.pushEventTo(`#${_this.options.phxTarget}`, _this.options.phxLoadEvent, {});
    } else {
      _this.pushEvent(_this.options.phxLoadEvent, {});
    }

    // Add some delay to at least see the spinning icon and avoid flickering
    setTimeout(() => {
      const scrollTop = _this.scrollElement.scrollTop;
      if (scrollTop > _this.maxScrollTop) {
        _this.maxScrollTop = scrollTop;
        _this.hadScrollTopOverflow = true;
      }
      _this.scrollTopArrowIcon.style.display = "block";
      const spinner = _this.scrollTopButton.querySelector(".fa-spinner");
      spinner.style.display = "none";
    }, 1000);
  }
};
